import { Routes, Route, Navigate } from 'react-router-dom';
import BasicLayout from '@/components/layouts/BasicLayout';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import Login from '@/pages/login';
import Dashboard from '@/pages/dashboard';
import Users from '@/pages/users';
import Roles from '@/pages/roles';
import BroadcastAdmin from '@/pages/broadcast-admin';
import ControlCenter from '@/pages/control-center';
import CrewProfile from '@/pages/crew-profile';
import CrewProfileAdmin from '@/pages/crew-profile/Admin';
import Treasure from '@/pages/treasure';
import MobileApp from '@/pages/mobile/MobileApp';
import { useIsMobile } from '@/hooks/useIsMobile';

function AppRouter() {
  const isMobile = useIsMobile();

  return (
    <Routes>
      {/* 根路径重定向到登录页 */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* 登录页面 */}
      <Route path="/login" element={<Login />} />

      {/* Dashboard页面 - 独立全屏显示 */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {isMobile ? <MobileApp /> : <Dashboard />}
          </ProtectedRoute>
        }
      />

      {/* 星舰广播中心 - 管理员独立页面 */}
      <Route
        path="/broadcast-admin"
        element={
          <ProtectedRoute>
            <BroadcastAdmin />
          </ProtectedRoute>
        }
      />

      {/* 星舰控制中心 - 管理员独立页面 */}
      <Route
        path="/control-center"
        element={
          <ProtectedRoute>
            <ControlCenter />
          </ProtectedRoute>
        }
      />

      {/* 机组信息管理 - 个人维护页 */}
      <Route
        path="/crew-profile"
        element={
          <ProtectedRoute>
            <CrewProfile />
          </ProtectedRoute>
        }
      />

      {/* 星舰机组管理 - 管理员独立页面 */}
      <Route
        path="/crew-management"
        element={
          <ProtectedRoute>
            <CrewProfileAdmin />
          </ProtectedRoute>
        }
      />

      {/* 我的宝箱 - 独立全屏页面 */}
      <Route
        path="/treasure"
        element={
          <ProtectedRoute>
            <Treasure />
          </ProtectedRoute>
        }
      />

      {/* 主应用布局 - 需要登录才能访问 */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <BasicLayout />
          </ProtectedRoute>
        }
      >
        <Route path="users" element={<Users />} />
        <Route path="roles" element={<Roles />} />
      </Route>

      {/* 所有未匹配的路径重定向到登录页 */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default AppRouter;
